import React from 'react';
import { Hidden } from '@material-ui/core';
import Tooltip from '@cpg-its/ads.common.tooltip';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { declineMedicalDentalTableStyles } from '../../../../../Global/constants/theme/styles/tables/decline-medical-dental-table';
import { DeclineMedicalDentalWizard } from './wizard/decline-medical-dental-wizard';
import { OePlanOffer } from '../institution-model';
import { TiersTypes } from '../../new-hire-enrollment/enrollment/models/coverage-models';


interface Props {
	wizard: DeclineMedicalDentalWizard;
	plans: OePlanOffer[];
	declinedTitle: string;
}

export function DeclineMedicalDentalView(props: Props) {

	const classes = declineMedicalDentalTableStyles();
	const { wizard, plans, declinedTitle } = props;
	const contentModel = wizard?.getFormContentModel();
	const year = wizard?.getCurrentYear();
	const enrolledPlan = plans?.filter(plan => !plan?.optout);
	const declinedPlan = plans?.filter(plan => plan?.optout);

	return (
		<>
			<ContentSpacer>
				<div className={classes.declineMedicalDentalTable}>
					<Hidden mdDown>
						<div className='main-row grey-row-dark'>
							<div className='main-row-cell header-cell'>
								<h4>{contentModel?.detailLabel}</h4>
							</div>
							<div className='main-row-cell header-cell'>
								<h4>{contentModel?.ratesLabel?.replace('{year}', year?.toString())}</h4>
							</div>
						</div>
					</Hidden>
					<Hidden mdDown>
						<div className='main-row grey-row-medium'>
							<div className='main-row-cell'>
								<div className='internal-row'>
									<div className='internal-row-cell internal-row-cell-sm'><p><strong>{contentModel?.planCodeLabel}</strong></p></div>
									<div className='internal-row-cell internal-row-cell-lg'><p><strong>{contentModel?.descriptionLabel}</strong></p></div>
								</div>

							</div>
							<div className='main-row-cell'>
								<div className='internal-row'>
									{wizard?.planHasTier(plans[0], TiersTypes.Single) && <div className='internal-row-cell'><p><strong>{contentModel?.tier1Label}</strong></p></div>}
									{wizard?.planHasTier(plans[0], TiersTypes.EmpPlusOne) && <div className='internal-row-cell'><p><strong>{wizard.getPlusOneLabel(plans[0])}</strong></p></div>}
									{wizard?.planHasTier(plans[0], TiersTypes.EmpPlusChild) && <div className='internal-row-cell'><p><strong>{contentModel?.tier4Label}</strong></p></div>}
									{wizard?.planHasTier(plans[0], TiersTypes.EmpPlusMulti) && <div className='internal-row-cell'><p><strong>{contentModel?.tier5Label}</strong></p></div>}
									{wizard?.planHasTier(plans[0], TiersTypes.Family) && <div className='internal-row-cell'><p><strong>{contentModel?.tier6Label}</strong></p></div>}
								</div>
							</div>
						</div>
					</Hidden>
					{
						enrolledPlan?.map(plan =>
							<div className='main-row'>
								<div className='main-row-cell'>
									<div className='internal-row'>
										<div className='internal-row-cell internal-row-cell-sm'><Hidden lgUp><p><strong>{contentModel?.planCodeLabel}</strong></p></Hidden><p>{plan?.plan_code}</p></div>
										<div className='internal-row-cell internal-row-cell-lg'><Hidden lgUp><p><strong>{contentModel?.planNameLabel}</strong></p></Hidden><p>{plan?.plan_name}</p></div>
									</div>
								</div>
								<div className='main-row-cell'>
									<div className='internal-row'>
										<Hidden lgUp>
											<div className='internal-row-cell'>
												<h4>{contentModel?.ratesLabel?.replace('{year}', year?.toString())}</h4>
											</div>
										</Hidden>
										{wizard?.planHasTier(plans[0], TiersTypes.Single) && <div className='internal-row-cell'><Hidden lgUp><p><strong>{contentModel?.tier1Label}</strong></p></Hidden><p>{wizard?.getRateDisplay(plan, TiersTypes.Single)}</p></div>}
										{wizard?.planHasTier(plans[0], TiersTypes.EmpPlusOne) && <div className='internal-row-cell'><Hidden lgUp><p><strong>{wizard.getPlusOneLabel(plans[0])}</strong></p></Hidden><p>{wizard?.getRateDisplay(plan, TiersTypes.EmpPlusOne)}</p></div>}
										{wizard?.planHasTier(plans[0], TiersTypes.EmpPlusChild) && <div className='internal-row-cell'><Hidden lgUp><p><strong>{contentModel?.tier4Label}</strong></p></Hidden><p>{wizard?.getRateDisplay(plan, TiersTypes.EmpPlusChild)}</p></div>}
										{wizard?.planHasTier(plans[0], TiersTypes.EmpPlusMulti) && <div className='internal-row-cell'><Hidden lgUp><p><strong>{contentModel?.tier5Label}</strong></p></Hidden><p>{wizard?.getRateDisplay(plan, TiersTypes.EmpPlusMulti)}</p></div>}
										{wizard?.planHasTier(plans[0], TiersTypes.Family) && <div className='internal-row-cell'><Hidden lgUp><p><strong>{contentModel?.tier6Label}</strong></p></Hidden><p>{wizard?.getRateDisplay(plan, TiersTypes.Family)}</p></div>}
									</div>
								</div>
							</div>,
						)
					}
				</div>
			</ContentSpacer>
			<ContentSpacer>
				{
					declinedPlan?.length !== 0 &&
					<ContentSpacer>
						<h3>{declinedTitle}</h3>
					</ContentSpacer>
				}
				<div className={classes.declineMedicalDentalTable}>
					{
						declinedPlan?.map(plan =>
							<div className='main-row main-row-alert'>
								<div className='main-row-cell'>
									<div className='internal-row'>
										<div className='internal-row-cell internal-row-cell-sm'><Hidden lgUp><p><strong>{contentModel?.planCodeLabel}</strong></p></Hidden><p>{plan?.plan_code}</p></div>
										<>

											<div className='internal-row-cell internal-row-cell-lg'>
												<Hidden lgUp><p><strong>{contentModel?.planNameLabel}</strong></p></Hidden>
												<div className='internal-row-cell-description'>
													<div className='internal-row-cell-alert'>
														<Tooltip title={contentModel?.declinePlanHelperText} />
														<p className='internal-row-cell-alert-text'><strong>{contentModel?.declinePlanText}</strong></p>
													</div>
													<p>{plan?.plan_name}</p>
												</div>
											</div>
										</>
									</div>

								</div>
								<div className='main-row-cell'>
									<div className='internal-row'>
										<Hidden lgUp>
											<div className='internal-row-cell'>
												<h4>{contentModel?.ratesLabel?.replace('{year}', year?.toString())}</h4>
											</div>
										</Hidden>
										{wizard?.planHasTier(plans[0], TiersTypes.Single) && <div className='internal-row-cell'><Hidden lgUp><p><strong>{contentModel?.tier1Label}</strong></p></Hidden><p>{wizard?.getRateDisplay(plan, TiersTypes.Single)}</p></div>}
										{wizard?.planHasTier(plans[0], TiersTypes.EmpPlusOne) && <div className='internal-row-cell'><Hidden lgUp><p><strong>{wizard.getPlusOneLabel(plans[0])}</strong></p></Hidden><p>{wizard?.getRateDisplay(plan, TiersTypes.EmpPlusOne)}</p></div>}
										{wizard?.planHasTier(plans[0], TiersTypes.EmpPlusChild) && <div className='internal-row-cell'><Hidden lgUp><p><strong>{contentModel?.tier4Label}</strong></p></Hidden><p>{wizard?.getRateDisplay(plan, TiersTypes.EmpPlusChild)}</p></div>}
										{wizard?.planHasTier(plans[0], TiersTypes.EmpPlusMulti) && <div className='internal-row-cell'><Hidden lgUp><p><strong>{contentModel?.tier5Label}</strong></p></Hidden><p>{wizard?.getRateDisplay(plan, TiersTypes.EmpPlusMulti)}</p></div>}
										{wizard?.planHasTier(plans[0], TiersTypes.Family) && <div className='internal-row-cell'><Hidden lgUp><p><strong>{contentModel?.tier6Label}</strong></p></Hidden><p>{wizard?.getRateDisplay(plan, TiersTypes.Family)}</p></div>}
									</div>
								</div>
							</div>,
						)
					}
				</div>
			</ContentSpacer>
		</>
	);
}
